import { NgFor, NgForOf, NgIf, NgTemplateOutlet } from '@angular/common';
import { Component, Input, ViewChild } from '@angular/core';
import { RouterModule } from '@angular/router';
import { IconPipe } from '@/shared/pipes/icon.pipe';
import { RoutingDirective } from '@/routing.directive';
import {
  IconModule,
  ListModule,
  SidenavComponent as SidenavComponentMomentum,
  SidenavModule,
  TypeModule,
} from '@virginmediao2/momentum-angular';
import { StrapiInterface } from '@/shared/interfaces';

@Component({
  selector: 'vm-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss'],
  imports: [
    RouterModule,
    IconModule,
    SidenavModule,
    ListModule,
    TypeModule,
    ListModule,
    NgFor,
    NgIf,
    NgTemplateOutlet,
    NgForOf,
    IconPipe,
    RoutingDirective,
  ],
  standalone: true,
})
export class SidenavComponent {
  @Input({ required: true }) data!: StrapiInterface['navigation'];
  @ViewChild('vosidenav')
  sidenav!: SidenavComponentMomentum;

  closeSideNav(e: any) {
    this.sidenav?.handleClose(e);
  }
}
